import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  IconButtonProps,
  List,
  Text,
  useColorModeValue,
  useDisclosure,
  VStack
} from "@chakra-ui/react";
import { ProtectedComponent } from "components/Atomos/ProtectedComponent";
import { useEffect, useState } from "react";
import { RiArrowLeftLine, RiMenuLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { InputSearch } from "../../../components/Atomos/Form/Elements/InputSearch";
import { MenuItemProps, useMenu } from "../../../_config/menu";
import { Footer } from "./Footer";
import { MobileMenuItem } from "./MobileMenuItem";

type MobileMenuProps = Omit<IconButtonProps, "aria-label">;

interface MenuContentProps {
  items: MenuItemProps[];
  title: string;
}

interface MenuProps {
  previous: MenuContentProps[];
  current: MenuContentProps;
}

export const MobileMenu = (props: MobileMenuProps) => {
  const [search, setSearch] = useState<string>("");

  const { filterMenu } = useMenu([]);
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const contentColor = useColorModeValue("", "gray.800");
  const color = useColorModeValue("gray.800", "white");

  const [menuList, setMenuList] = useState<MenuProps>({
    previous: [],
    current: { title: "", items: [] }
  });
  const voltarColor = useColorModeValue("gray.500", "gray.400");

  useEffect(() => {
    const menuFiltered = filterMenu(search);
    setMenuList({
      previous: [],
      current: { title: "Menu", items: menuFiltered }
    });
  }, [search]);

  const selectMenu = (m: MenuItemProps) => {
    if (m.subMenu) {
      const newList = m.subMenu;
      setMenuList((state) => ({
        previous: [state.current, ...state.previous],
        current: { title: m.name, items: newList }
      }));
    } else {
      if (m.to) navigate(m.to);
      onClose();
    }
  };

  const voltarMenu = () => {
    setMenuList((state) => {
      const arr = state.previous;
      return {
        previous: arr.slice(1),
        current: arr[0]
      };
    });
  };

  return (
    <>
      <IconButton
        size="md"
        variant="ghost"
        color="current"
        onClick={onOpen}
        icon={<RiMenuLine size="1.6rem" />}
        aria-label={`Menu button`}
        {...props}
      />
      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent pt="12" bgColor={contentColor} color={color}>
          <DrawerHeader py={2}>
            <Box mb={2}>
              <InputSearch timer={0} onChangeValue={setSearch} />
            </Box>
            <VStack alignItems="baseline">
              {menuList.previous.length > 0 && (
                <Button
                  color={voltarColor}
                  variant="link"
                  leftIcon={<RiArrowLeftLine />}
                  fontWeight="medium"
                  size="md"
                  py="2"
                  justifyContent="flex-start"
                  isTruncated
                  maxW="full"
                  onClick={() => voltarMenu()}
                >
                  {menuList.previous[0].title}
                </Button>
              )}
              <Text mt={2} isTruncated maxW="full">
                {menuList.current.title}
              </Text>
            </VStack>
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody p="0">
            <Flex direction="column" justifyContent="space-between" h="100%">
              <List>
                {menuList.current.items.map((x) => (
                  <ProtectedComponent
                    key={x.name + x.to}
                    rolesRequired={x.roleTypes || []}
                  >
                    <MobileMenuItem
                      icon={x.icon}
                      name={x.name}
                      hasSubMenu={!!x.subMenu}
                      onClick={() => selectMenu(x)}
                    />
                  </ProtectedComponent>
                ))}
              </List>
            </Flex>
          </DrawerBody>
          <DrawerFooter p={0}>
            <Footer />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
